import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import SignaturePad from 'signature_pad';
import { API } from 'src/app/app.config';
import { LoginService, UsuarioService } from 'src/app/services';

@Component({
  selector: 'app-alterar-assinatura',
  standalone: false,
  templateUrl: './alterar-assinatura.component.html',
  styleUrl: './alterar-assinatura.component.scss'
})
export class AlterarAssinaturaComponent {

  @ViewChild('sPad') signaturePadElement?: ElementRef;
  signaturePad: any;
  Api = API;

  private sPad: ElementRef;

  @ViewChild('sPad') set content(content: ElementRef) {
    if (content) {
      this.sPad = content;
      this.signaturePad = new SignaturePad(this.sPad.nativeElement);
    }
  }

usuario: any;
  registrada = false;

  constructor(private loginService: LoginService,
    private usuarioService: UsuarioService,
     private modalService: NgbModal
   ) {
      this.usuario = this.loginService.user();
   }

  ngOnInit() {
  }
salvarAssinatura() {
    if (this.signaturePad.isEmpty()) {
      alert('Please provide a signature first.');
    } else {
      const dataURL = this.signaturePad.toDataURL();
      this.uploadAssinatura(dataURL);
    }
  }

  uploadAssinatura(imagem) {
    this.usuarioService.uploadAssinatura(imagem, this.usuario.Id).subscribe(
      (dados) => {

        this.usuario.AssinaturaDigitalizada = "/uploads/usuario/" + dados;
      },
      (erros) => {
        console.log("Erro ao subir a assinatura.");
        console.log(erros);
      }
    );
  }
  limpar() {
    this.signaturePad.clear();
  }

  fecharModal() {
           this.modalService.dismissAll();
     }
}
